export interface MinigameSession {
  question?: string
  choices?: { a: string; b: string }
  my_answer: 'A' | 'B' | null
  other_answered: boolean
  expires_at?: string
  session_id?: number
  active?: boolean
  revealed?: boolean
}

interface MinigameOverlayProps {
  session: MinigameSession | null
  timeLeft: number
  onAnswer: (choice: 'A' | 'B') => void
  onClose: () => void
}

export default function MinigameOverlay({ session, timeLeft, onAnswer, onClose }: MinigameOverlayProps) {
  if (!session) return null

  return (
    <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-base-100 rounded-2xl shadow-2xl max-w-md w-full p-6 space-y-4 relative">
        {/* 닫기 버튼 */}
        <button
          onClick={onClose}
          className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          title="닫기"
        >
          ✕
        </button>

        <div className="text-center">
          <h3 className="text-2xl font-bold mb-2">🎮 동시답변 게임!</h3>
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="text-lg font-bold text-primary">
              {timeLeft}초
            </span>
            <span className="text-sm text-base-content/60">남음</span>
          </div>
          <div className="w-full bg-base-200 rounded-full h-2 mb-4">
            <div
              className="bg-primary h-2 rounded-full transition-all duration-100"
              style={{ width: `${(timeLeft / 10) * 100}%` }}
            />
          </div>
        </div>

        <div className="bg-gradient-to-r from-primary/10 to-secondary/10 p-4 rounded-xl">
          <p className="text-center font-semibold text-lg">
            {session.question}
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => onAnswer('A')}
            disabled={session.my_answer !== null}
            className={`btn btn-lg w-full ${session.my_answer === 'A'
              ? 'btn-primary'
              : 'btn-outline btn-primary'
              }`}
          >
            <span className="text-xl mr-2">A</span>
            <span className="flex-1 text-left">{session.choices?.a}</span>
            {session.my_answer === 'A' && (
              <span className="ml-2">✓</span>
            )}
          </button>

          <button
            onClick={() => onAnswer('B')}
            disabled={session.my_answer !== null}
            className={`btn btn-lg w-full ${session.my_answer === 'B'
              ? 'btn-primary'
              : 'btn-outline btn-primary'
              }`}
          >
            <span className="text-xl mr-2">B</span>
            <span className="flex-1 text-left">{session.choices?.b}</span>
            {session.my_answer === 'B' && (
              <span className="ml-2">✓</span>
            )}
          </button>
        </div>

        {session.my_answer && (
          <div className="text-center">
            {session.other_answered ? (
              <p className="text-sm text-success animate-pulse">
                🎉 두 분 모두 답변하셨습니다! 결과 공개 중...
              </p>
            ) : (
              <p className="text-sm text-base-content/60">
                ⏳ 상대방의 답변을 기다리는 중...
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
